import { render, staticRenderFns } from "./TabsSelectBooksInPlan.vue?vue&type=template&id=0b76926e&scoped=true&"
import script from "./TabsSelectBooksInPlan.vue?vue&type=script&lang=js&"
export * from "./TabsSelectBooksInPlan.vue?vue&type=script&lang=js&"
import style0 from "./TabsSelectBooksInPlan.vue?vue&type=style&index=0&id=0b76926e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76926e",
  null
  
)

export default component.exports